angular
  .module('app')
  .directive('d3Donuts', ['d3Service', '$window', '$timeout', function(d3Service, $window, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        data: '=',
        src: '=',
        options: '='
      },
      link: function(scope, el, attrs) {
        d3Service.d3().then(function(d3) {
          scope.render = {};

          var renderTimeout;

          $window.onresize = function() {
            scope.$apply();
          };

          scope.$watch(function() {
            return angular.element($window)[0].innerWidth;
          }, function() {
            scope.render[scope.src](scope.data);
          });

          scope.$watch('data', function(newData) {
            scope.render[scope.src](newData);
          }, true);

          scope.onClick = function (d) {
              console.info('d3 part click', d.data);
          };

          scope.render[scope.src] = function(data) {
            var tmp = angular.element(el[0]);
            tmp.find('svg:not(:last)').remove();

            if (!data) return;
            if (renderTimeout) clearTimeout(renderTimeout);

            renderTimeout = $timeout(function() {
              if (scope.src === 'turnover_by_time')
                console.error(d3.select(el[0]).node().offsetWidth);


              var width = el.parent()[0].offsetWidth,
                  height = width,
                  radius = Math.min(width, height) / 2,
                  color = function(s) {
                    return s.data.color;
                  };

              // var color = d3.scaleSequential(function(s) { //d.data.value
              //               return d3.interpolateRainbow(s/100);
              //             });

              var arc = d3.arc()
                  .outerRadius(radius - 10)
                  .innerRadius(radius - 70);

              var pie = d3.pie()
                  .sort(null)
                  .value(function(d) { return d.value; });

              svg = d3.select(el[0])
                      .append('svg')
                      .style('width', '100%')
                      .attr('width', width)
                      .attr('height', height)
                      .append('g')
                      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

              // 

              var g = svg.selectAll('.arc')
                  .data(pie(data))
                  .enter()
                  .append('g')
                  .attr('class', 'arc');

              g.append('path')
                  .attr('d', arc)
                  .style('fill', function(d) { return color(d); });
                  // .on('click', function(d, i) { return scope.onClick(d); });
                  // .on("mouseover", function(d, i) { return scope.onClick(d); })
                  // .on("mouseout", function(d, i) { return scope.onClick(d); });

              // g.append('text')
              //     .attr('transform', function(d) { return 'translate(' + arc.centroid(d) + ')'; })
              //     .attr('dx', '-40px')
              //     .attr('dy', '0')
              //     .attr('fill', '#fff')
              //     .style("font-size", "12px")
              //     .text(function(d) { return d.data.value; });

              function type(d) {
                d.value = +d.value;
                return d;
              }
            }, 100);
          };
        });
      }};
  }]);
